import { addCircleIcon, userBlack } from '../../../../assets/hostedassets';
import styles from '../../GlobalSearch.module.scss';
import { GlobalSearchResult } from '../../useSearchResultFetcher';
import OfficeIcon from '../../../../assets/Svg/OfficeIcon';

type AddNewPillProps = {
    result: GlobalSearchResult;
};

const AddNewPill = ({ result }: AddNewPillProps) => {
    const baseIcon = result.isIndividualPan ? userBlack : null;

    return (
        <div className={styles.AddNewPill}>
            <>
                {baseIcon ? (
                    <img src={baseIcon} alt="org" className={`${styles.PillIcon} ${styles.PillIconDefault}`} />
                ) : (
                    <OfficeIcon className={`${styles.PillIcon} ${styles.PillIconDefault}`} />
                )}
                <img src={addCircleIcon} alt={'add'} className={`${styles.PillIcon} ${styles.PillIconHover}`} />
            </>
            <span className={styles.OrgName}>{result.orgName}</span>
        </div>
    );
};

export default AddNewPill;
